"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles_1 = require("@mui/material/styles");
var Box_1 = require("@mui/material/Box");
var Post_1 = require("./Post");
var Fab_1 = require("@mui/material/Fab");
var Add_1 = require("@mui/icons-material/Add");
var PostModal_1 = require("./PostModal");
var Post_2 = require("../models/Post");
var Download_1 = require("@mui/icons-material/Download");
var PostService_1 = require("../services/PostService");
var react_infinite_scroll_hook_1 = require("react-infinite-scroll-hook");
var material_1 = require("@mui/material");
var StorageService_1 = require("../shared/storage/StorageService");
var StorageKeys_1 = require("../shared/storage/StorageKeys");
var Role_1 = require("../shared/utilities/Role");
var Toast_1 = require("../shared/utilities/Toast");
var DrawerHeader = styles_1.styled("div")(function (_a) {
    var theme = _a.theme;
    return (__assign({ display: "flex", alignItems: "center", justifyContent: "flex-end", padding: theme.spacing(0, 1) }, theme.mixins.toolbar));
});
/*const originalPosts : PostModel[] = [
    {
        id: '0',
        name: "Katie and Bob McInnes",
        nameAbbr: "KB",
        postDate: "September 14, 2016 2:00 PM",
        postBody: "Welcome to the Hidden Glen Webpage! This is where we will post the various and events and upates for all of you to see!",
        postImageUrl: "https://hiddenglen.ca/img/places-to-stay-on-georgian-bay.jpg"
    },
    {
        id: '1',
        name: "Katie and Bob McInnes",
        nameAbbr: "KB",
        postDate: "September 10, 2016 10:20 AM",
        postBody: "Hello everyone, we have added a new event for next weekend, check out the events page to see it!",
        postImageUrl: ""
    },
]*/
function BulletinBoard() {
    var _this = this;
    var _a = Toast_1.default(), showErrorMessage = _a.showErrorMessage, showSuccessMessage = _a.showSuccessMessage;
    var _b = React.useState(false), ready = _b[0], setReady = _b[1];
    var role = Role_1.default();
    var modalRef = React.useRef(null);
    var _c = React.useState([]), posts = _c[0], setPosts = _c[1];
    var _d = React.useState(0), pageNumber = _d[0], setPageNumber = _d[1];
    var _e = React.useState(5), pageSize = _e[0], setPageSize = _e[1];
    var _f = React.useState(true), hasNextPage = _f[0], setHasNextPage = _f[1];
    var _g = React.useState(false), loading = _g[0], setLoading = _g[1];
    var deletePost = function (id) {
        setReady(false);
        var post = posts.filter(function (post) { return post.PostId == id; })[0];
        PostService_1.default.UpdatePost(post.PostId, post.PostUser.UserId, post.PostBody, null, null, post.SendEmailNotificationInd, post.PostImmediatelyInd, post.PostFutureTime, true).then(function (response) {
            if (response != null && response.Post != null) {
                var newSetPosts = __spreadArray([], posts);
                var index = newSetPosts.map(function (post) { return post.PostId; }).indexOf(id);
                newSetPosts.splice(index, 1);
                setPosts(__spreadArray([], newSetPosts));
                showSuccessMessage('Post deleted successfully!');
            }
            else {
                showErrorMessage('Unknown error occured deleting post!');
            }
            setReady(true);
        });
    };
    var upsertPost = function (post, imageBytes, imageName) { return __awaiter(_this, void 0, void 0, function () {
        var userId, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = Number;
                    return [4 /*yield*/, StorageService_1.default.get(StorageKeys_1.Auth.Id)];
                case 1:
                    userId = _a.apply(void 0, [_b.sent()]);
                    setReady(false);
                    if (post.PostId == null || post.PostId == '') {
                        PostService_1.default.CreatePost(userId, post.PostBody, imageName, imageBytes, post.SendEmailNotificationInd, post.PostImmediatelyInd, post.PostFutureTime).then(function (response) {
                            if (response != null && response.Post != null) {
                                var newSetPosts = posts;
                                if (response.Post.PostTime != null) {
                                    response.Post.PostTime = new Date(response.Post.PostTime);
                                }
                                if (response.Post.PostFutureTime != null) {
                                    response.Post.PostFutureTime = new Date(response.Post.PostFutureTime);
                                }
                                newSetPosts.unshift(response.Post);
                                console.log('new post set', newSetPosts);
                                setPosts(__spreadArray([], newSetPosts));
                                showSuccessMessage('Post added successfully!');
                            }
                            else {
                                showErrorMessage('Unknown error occured adding post!');
                            }
                            setReady(true);
                        });
                    }
                    else {
                        PostService_1.default.UpdatePost(post.PostId, userId, post.PostBody, imageName, imageBytes, post.SendEmailNotificationInd, post.PostImmediatelyInd, post.PostFutureTime, false).then(function (response) {
                            if (response != null && response.Post != null) {
                                var newSetPosts = __spreadArray([], posts);
                                if (response.Post.PostTime != null) {
                                    response.Post.PostTime = new Date(response.Post.PostTime);
                                }
                                if (response.Post.PostFutureTime != null) {
                                    response.Post.PostFutureTime = new Date(response.Post.PostFutureTime);
                                }
                                var index = newSetPosts.map(function (post) { return post.PostId; }).indexOf(response.Post.PostId);
                                console.log('index found', index);
                                console.log('response', response);
                                var item = __assign(__assign({}, posts[index]), { PostBody: response.Post.PostBody, PostFutureTime: response.Post.PostFutureTime, PostImageLocation: response.Post.PostImageLocation, PostImmediatelyInd: response.Post.PostImmediatelyInd, PostUser: response.Post.PostUser, PostTime: response.Post.PostTime });
                                console.log(newSetPosts);
                                newSetPosts[index] = item;
                                setPosts(__spreadArray([], newSetPosts));
                                showSuccessMessage('Post updated successfully!');
                            }
                            else {
                                showErrorMessage('Unknown error occured updating post!');
                            }
                            setReady(true);
                        });
                    }
                    return [2 /*return*/, true];
            }
        });
    }); };
    var openPostModal = function (post) {
        var _a, _b;
        if (post == null || post.PostId == '') {
            var newPost = new Post_2.PostModel();
            console.log('new post', newPost);
            modalRef && ((_a = modalRef === null || modalRef === void 0 ? void 0 : modalRef.current) === null || _a === void 0 ? void 0 : _a.handleOpen(newPost));
        }
        else {
            modalRef && ((_b = modalRef === null || modalRef === void 0 ? void 0 : modalRef.current) === null || _b === void 0 ? void 0 : _b.handleOpen(post));
        }
    };
    var getNextPage = function () {
        setLoading(true);
        var newPageNumber = pageNumber + 1;
        setPageNumber(newPageNumber);
        PostService_1.default.GetPosts(newPageNumber, pageSize).then(function (response) {
            if (response.Posts.length == 0) {
                setHasNextPage(false);
            }
            setPosts(posts.concat(response.Posts));
            setLoading(false);
        });
    };
    React.useEffect(function () {
        console.log('effect used');
        PostService_1.default.GetPosts(pageNumber, pageSize).then(function (response) {
            if (response != null && response.Posts != null && response.error == null) {
                setPosts(response.Posts);
            }
            else {
                showErrorMessage('Unknown error occured getting posts!');
            }
            setReady(true);
        }).catch(function (error) {
            //TODO: add error
        });
    }, []);
    var _h = react_infinite_scroll_hook_1.default({
        loading: loading,
        hasNextPage: hasNextPage,
        onLoadMore: getNextPage,
        disabled: false,
        rootMargin: '0px 0px 100px 0px',
    }), sentryRef = _h[0], rootRef = _h[1].rootRef;
    return (React.createElement(Box_1.default, { component: "main", sx: { flexGrow: 1, p: 3, marginBottom: '40px' } },
        React.createElement(DrawerHeader, null),
        !ready &&
            React.createElement("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'center' } },
                React.createElement(material_1.CircularProgress, { size: 100, disableShrink: true })),
        ready &&
            React.createElement(React.Fragment, null,
                role === 'Admin' &&
                    React.createElement(Fab_1.default, { color: "primary", style: { float: 'right', marginBottom: '8px' }, variant: "extended", onClick: function () {
                            openPostModal(new Post_2.PostModel());
                        } },
                        React.createElement(Add_1.default, null),
                        " Add New Post"),
                React.createElement(Fab_1.default, { color: "primary", style: { float: 'right', marginBottom: '8px', marginRight: '8px' }, variant: "extended", onClick: function () {
                        var docLocation = 'https://hiddenglenblobstorage.blob.core.windows.net/eventlist/currentEventList.pdf';
                        var fileType = docLocation.split('.').pop();
                        fetch(docLocation, {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/' + fileType,
                            },
                        })
                            .then(function (response) { return response.blob(); })
                            .then(function (blob) {
                            var _a;
                            // Create blob link to download
                            var url = window.URL.createObjectURL(new Blob([blob]));
                            var link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', 'eventList' + "." + fileType);
                            // Append to html link element page
                            document.body.appendChild(link);
                            // Start download
                            link.click();
                            // Clean up and remove the link
                            (_a = link.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(link);
                        });
                    } },
                    React.createElement(Download_1.default, null),
                    " Event List"),
                React.createElement("br", null),
                React.createElement(material_1.List, null,
                    posts.map(function (post) { return (React.createElement(material_1.ListItem, { sx: { paddingRight: 0, paddingLeft: 0 }, key: post.PostId },
                        React.createElement(Post_1.default, { id: post.PostId, firstName: post.PostUser == null ? '' : post.PostUser.FirstName, lastName: post.PostUser == null ? '' : post.PostUser.LastName, postDate: post.PostTime, postBody: post.PostBody, postImageUrl: post.PostImageLocation, postImmediatelyInd: post.PostImmediatelyInd, sendEmailNotificationInd: post.SendEmailNotificationInd, postFutureTime: post.PostFutureTime, openPostModal: openPostModal, delete: deletePost }))); }),
                    (loading || hasNextPage) && (React.createElement(material_1.ListItem, { ref: sentryRef, style: { justifyContent: 'center' }, key: "loading" },
                        React.createElement(material_1.CircularProgress, { size: 100, disableShrink: true }))))),
        React.createElement(PostModal_1.default, { ref: modalRef, upsertPost: upsertPost })));
}
exports.default = BulletinBoard;
//# sourceMappingURL=BulletinBoard.js.map